<template>
  <div class="ear-lobe-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">
        Ear Lobe Repair & Non-Surgical Ear Reshaping
      </h2>
      <p>
        "At Diverse Care Now, we offer simple and safe procedures to restore
        balance, correct asymmetries, and repair ear lobes — without the need
        for traditional surgery. Our goal is to deliver natural results with
        minimal downtime."
      </p>
      <h3>Who Can Benefit from Otomodeling?</h3>
      <ul>
        <li>Patients with stretched or torn earlobes (often from earrings).</li>
        <li>Individuals with protruding or asymmetrical ears.</li>
        <li>Small irregularities not requiring surgery.</li>
        <li>Clients seeking subtle, scar-free corrections.</li>
      </ul>
      <h3>Techniques</h3>
      <ul>
        <li>
          Dermal Fillers — restore shape and volume for a more balanced ear
          contour.
        </li>
        <li>
          PDO / PLLA Threads — minimally invasive lifting to correct angles and
          improve symmetry.
        </li>
        <li>
          PRP or Filler Rejuvenation — restore elasticity and prevent further
          tearing.
        </li>
        <li>Cyst Removal — quick, safe procedure with local anesthesia.</li>
      </ul>
      <h3>Procedure Overview</h3>
      <ul>
        <li>Local anesthesia for comfort.</li>
        <li>Application of fillers, threads, or PRP as needed.</li>
        <li>Immediate results, minimal swelling (24–48h).</li>
      </ul>
      <p>
        From cosmetic earlobe rejuvenation to cyst removal, our minimally
        invasive procedures are designed to restore comfort, balance, and
        confidence.
      </p>
    </div>
    <div class="otomodeling-video">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/9rbA47bOvms"
        title="YouTube Shorts: Ear Lobe Repair"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "EarLobeRepairContentEn",
};
</script>

<style scoped>
.ear-lobe-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.otomodeling-video {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}

.otomodeling-video iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .ear-lobe-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .otomodeling-video {
    align-self: center;
  }

  .otomodeling-video iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .otomodeling-video iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
